<script>
  import { onMount } from "svelte";
  import auth from "./authService";
  import { isAuthenticated, user, user_tasks, tasks } from "./store";
  import TaskItem from "./components/TaskItem.svelte";

  let auth0Client;
  let newTask;

  onMount(async () => {
    auth0Client = await auth.createClient();

    isAuthenticated.set(await auth0Client.isAuthenticated());
    user.set(await auth0Client.getUser());
  });

  function login() {
    auth.loginWithPopup(auth0Client);
  }

  function logout() {
    auth.logout(auth0Client);
  }
	let concept_box;
	let question = '';
	let concept = 'wizard';
	let num_hits = 0;
	  const apiURL = "https://rest.metonymize.us:8983/solr/gcc-image-text-concepts-lut/query?rows=100&q.op=OR&q=Description_t:";
	let explorer_words = ["Who", "Where", "What", "Why", "How", "With", "When"];
	//let explorer_words = ["Belongs to", "Is a type of", "Causes", "Feels", "Does", "Opposes", "Relates"];

	let live_concept_list = [];
	  let logged_concept_data = new Set();
	  let keepOutputGuiInactive = true;
	let concatenated_concepts = '';

	/* Randomize array in-place using Durstenfeld shuffle algorithm */
	function shuffleArray(array) {
	    for (var i = array.length - 1; i > 0; i--) {
		var j = Math.floor(Math.random() * (i + 1));
		var temp = array[i];
		array[i] = array[j];
		array[j] = temp;
		    }
	    return(array)
		}

	function randomWordExtract(some_text,splitter) {
			return randomElement(some_text.split(splitter));
		}
	function randomElement(array) {
			return array[Math.floor(Math.random() * array.length)];
		}

	 async function getImageResults() {
			keepOutputGuiInactive = (!live_concept_list) && (!logged_concept_data)
			const active_url = apiURL+concept+"~0";
			const response1 = await fetch(active_url);
			//console.log(active_url);
			live_concept_list = await response1.json();
			num_hits = live_concept_list.response.numFound;
			live_concept_list = shuffleArray(live_concept_list.response.docs);
			//console.log(live_concept_list);
		};

	async function handleConceptKeydown(event) {
			console.log(keepOutputGuiInactive);
		if (event.key === 'Enter') {
			const text = event.target.value;
				if (!text) return;
			concept = text;
			getImageResults();
			};
		}
	async function log_item_on_click(item) {
			concept = randomElement(item.Labels_t.split(','));
			item["sampled_concept"]=concept;
			logged_concept_data.add(item);
			logged_concept_data = logged_concept_data;
			console.log(logged_concept_data);
			concept_box.focus();
		};

	async function removeLoggedItem(item) {
			logged_concept_data.delete(item);
			logged_concept_data = logged_concept_data;
		};

	async function export_aggregated_concepts(){
			[ ... logged_concept_data].forEach((_)=>{concatenated_concepts=concatenated_concepts+" "+_.sampled_concept});
			navigator.clipboard.writeText(concatenated_concepts);
			console.log(concatenated_concepts+":added to clipboard")
			//window.open('https://www.google.com/search?q='+concatenated_concepts);
			window.open('https://us1.list-manage.com/survey?u=cd4eb9eb314b5da2719efa0b6&id=aab507f7b7&attribution=false');
			concatenated_concepts = '';
		};
	function copy_on_click(item) {
			navigator.clipboard.writeText(item.Description_t);
			window.open('https://www.google.com/search?q='+item.sampled_concept);
			//navigator.clipboard.writeText(item.sampled_concept);
			//window.open('https://us1.list-manage.com/survey?u=cd4eb9eb314b5da2719efa0b6&id=aab507f7b7&attribution=false');
		};
	
	function pay_using_stripe()	{
			window.open('https://3wai.io/pay');
		};
	
	//<input bind:this={question_box} bind:value={question} on:keydown={handleQuestionKeydown} placeholder="enter the seed idea or question">
</script>

<main>
</main>

<style>
  #main-application {
    margin-top: 50px;
  }
</style>

<main>
  <!-- App Bar -->
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
	  <a class="navbar-brand" href="/#"><h1>MetoBoard</h1></a>
    <a
       class="btn btn-warning btn-lg mr-auto ml-auto"
       href="/#"
       role="button"
       on:click="{pay_using_stripe}"
	>Upgrade</a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarText"
      aria-controls="navbarText"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon" />
    </button>
    <div class="collapse navbar-collapse" id="navbarText">
      <div class="navbar-nav mr-auto user-details">
        {#if $isAuthenticated}
		<span class="text-white">&nbsp;&nbsp;{$user.name} ({$user.email})</span>
        {:else}<span>&nbsp;</span>{/if}
      </div>
      <span class="navbar-text">
        <ul class="navbar-nav float-right">
          {#if $isAuthenticated}
          <li class="nav-item">
            <a class="nav-link" href="/#" on:click="{logout}">Log Out</a>
          </li>
          {:else}
          <li class="nav-item">
            <a class="nav-link" href="/#" on:click="{login}">Log In</a>
          </li>
          {/if}
        </ul>
      </span>
    </div>
  </nav>

  <!-- Application -->
  <!--
  {#if !$isAuthenticated}
  <div class="container mt-5">
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <div class="jumbotron">
          <h1 class="display-4">Welcome to Metoboard!</h1>
	  <p>AI brainstorming for smarter mood boards.</p>
          <a
            class="btn btn-primary btn-md mr-auto ml-auto"
            href="/#"
            role="button"
            on:click="{login}"
            >Log In</a
          >
        </div>
      </div>
    </div>
  </div>
  {:else}
  -->
  <div class="container" id="main-application">
  			<div class="jumbotron">
				<h1 class="display-4">MindLink with MetoBoard</h1>
				<p class="lead">Enter a seed concept and then interactively create a mood board for intent activation.</p>
				<hr class="my-4">
				<div class="row">
					<div class="col-sm-6">
							  <div class="input-group input-group-lg">
								  <div class="input-group-prepend">
								    <span class="input-group-text" id="inputGroup-sizing-lg">Concept in focus</span>
								  </div>
								  <input type="text" bind:this={concept_box} 
									 bind:value={concept}
									 on:keydown={handleConceptKeydown}
									 placeholder="wizard"
									 class="form-control"
									 aria-label="Large"
									 aria-describedby="inputGroup-sizing-large">
							  </div>
					</div>
					 <div class="col-sm-2">
							<a class="btn btn-warning btn-lg mr-auto ml-auto"
									    href="/#"
									    role="button"
									    on:click="{getImageResults}"
									    >Sample</a>
					</div>
				</div>
		 	</div>

			{#if !keepOutputGuiInactive}

			<div class="jumbotron">
				<h1>🔭 Sample {num_hits} concepts ...</h1>
				<p>Click to toggle image concepts</p>
				{#each live_concept_list.slice(0,8) as item}
					<button on:click="{() => log_item_on_click(item)}">
					<figure>
						<img src={item.Image_url_s} alt={randomWordExtract(item.Labels_t, ",")} width=100> 
						<!-- <figcaption>{randomElement(explorer_words)}</figcaption> -->
						<figcaption>{randomWordExtract(item.Labels_t, ",")}</figcaption>
					</figure>
					</button>
				{/each}
			</div>
			<div class="jumbotron">
				<h1>💡 Load into working memory</h1>
				<p>Click to remove image concept</p>
				{#each [ ... logged_concept_data] as item2}
					<button on:click="{() => removeLoggedItem(item2)}">
					<figure>
						<img src={item2.Image_url_s} alt={item2.Description_t} width=100> 
						<figcaption>{item2.sampled_concept}</figcaption>
					</figure>
					</button>
				{/each}
			</div>

			<div class="jumbotron">
				<h1>🚀 
				<a
				    class="btn btn-warning btn-lg mr-auto ml-auto"
				    href="/#"
				    role="button"
				    on:click="{export_aggregated_concepts}"
				    >Merge and copy to clipboard and launch MindLink intent survey</a>
				</h1>
			</div>

			{/if}
  </div>
  <!-- {/if} -->
</main>
